<template>
  <div>

    <template >
      <v-card flat>
        <p class="title text-center pt-2">Total overview</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-card-text>
          <div v-for="item in countryObjectIntoArray" :key="item.id">
            <p class="subtitle-1">
              <span>Total articles: </span>
              <span class="font-weight-bold">{{item.articles}}</span>
            </p>
            <p class="subtitle-1">
              <span>Total new articles today: </span>
              <span class="font-weight-bold">{{item.newArticlesDay}}</span>
            </p>
            <p class="subtitle-1">
              <span>Total new articles this week: </span>
              <span class="font-weight-bold">{{item.newArticlesWeek}}</span>
            </p>
            <p class="subtitle-1">
              <span>Total new articles this month: </span>
              <span class="font-weight-bold">{{item.newArticlesMonth}}</span>
            </p>
            <p class="subtitle-1">
              <span>Total new articles this year: </span>
              <span class="font-weight-bold">{{item.newArticlesYear}}</span>
            </p>
          </div>
        </v-card-text>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$refs.statisticUserCardDialog.openDialog()" color="error">More Info</v-btn>
        </v-card-actions> -->
      </v-card>
    </template>
  </div>
</template>


<script>
// Import funcitons from store.js (vuex)
import { mapActions } from "vuex";
export default {
  data(){
    return{
      articleData: [],
    }
  },
  methods:{
    // Import these functions from store.js
    ...mapActions([
      "GET_ALL_ARTICLES"
    ]),

    getAllArticleData(){
      this.GET_ALL_ARTICLES().then(response => {
        response = response.map(el => {
          return {
            ...el,
           CreatedDays: this.$moment().diff(this.$moment(el.created), 'days'),
          }
        })
        this.articleData = response;
      })
    }
  },

  //CLEAN - AS IT IS PRETTY MUCH PASTE FROM TABLE

  
  computed:{
    // Filter and get the Article data served as we want it.
    filterArticleData(){
      let tmpUser = this.articleData[0];
      let thisDay = this.articleData.filter(article => article.CreatedDays === 0).length;
      let thisWeek = this.articleData.filter(article => article.CreatedDays < 7).length;
      let thisMonth = this.articleData.filter(article => article.CreatedDays < 31).length;
      let thisYear = this.articleData.filter(article => article.CreatedDays < 365).length;
      let seeAllDataYear = this.articleData.filter(article => article.CreatedDays < 365);
      let countries = {};
      this.articleData.map(article => article.Country).forEach(country => {
        if (!countries.hasOwnProperty(country)) {
          let thisDay = this.articleData.filter(article => article.Country === country).filter(article => article.CreatedDays === 0).length;
          let thisWeek = this.articleData.filter(article => article.Country === country).filter(article => article.CreatedDays < 7).length;
          let thisMonth = this.articleData.filter(article => article.Country === country).filter(article => article.CreatedDays < 31).length;
          let thisYear = this.articleData.filter(article => article.Country === country).filter(article => article.CreatedDays < 365).length;
          let total = this.articleData.filter(article => article.Country === country).length;
          let totalarticleData = this.articleData.filter(article => article.Country === country);
          // Where we put all these variables into countries,  which again goes into the return object below
          countries[country] = {thisDay, thisWeek, thisMonth, thisYear, total }
        }
      })
      return {thisDay, thisWeek, thisMonth, thisYear, seeAllDataYear, countries};
    },

    countryObjectIntoArray(){
      if (this.filterArticleData.countries ) {
        return Object.keys(this.filterArticleData.countries).map((key, index) => {
          let _return = {
            country: key,
            articles: this.filterArticleData.countries[key].total,
            newArticlesDay:  this.filterArticleData.countries[key].thisDay,
            newArticlesWeek: this.filterArticleData.countries[key].thisWeek,
            newArticlesMonth:  this.filterArticleData.countries[key].thisMonth,
            newArticlesYear:  this.filterArticleData.countries[key].thisYear,
            // articleGraph: this.filterArticleData.countries[key].totalarticleData.map(el => this.$moment().diff(this.$moment(el.Created), 'months')).sort((a,b) => {return a < b ? -1 : a > b ? 1 : 0}),
            // articleGraph: [1,1,1,1,5,5,5,5,6,7,8,9],
            // user:  this.filterArticleData.countries[key].totalarticleData,
            // test: this.filterArticleData.countries[key].datoer
          }
          // let articleGraph = new Array(12);
          // for (var i = 0; i < articleGraph.length; i++) {
          //   articleGraph[i] = this.filterArticleData.countries[key].totalarticleData.filter(el => this.$moment().diff(this.$moment(el.Created), 'months') == (articleGraph.length - i - 1)).length;
          // }
          // _return.articleGraph = articleGraph;
          return _return;
        });
      } else {
        return [];
      }
    },
  },
  // Run this function when page are loaded
  mounted() {
    this.getAllArticleData();
  }
}
</script>